import { Component } from "react";
import { getTimeString } from "../time";
import Typography from "@mui/material/Typography";
import "./DrawListDayItem.css";

class DrawListDayItem extends Component {
    GetStyleContainer() {
        return {
            width: "99%",
            display: "inline-flex",
        };
    }

    GetStyleInner(imputation) {
        return {
            height: "auto",
            marginTop: "auto",
            marginBottom: "auto",
            verticalAlign: "center",
            background: imputation.activity.color,
            width: "inherit",
            cursor: this.props.modifiable ? "pointer" : undefined,
            overflow: "hidden",
            position: "relative",
            float: "right",
            marginLeft: "0px",
            marginRight: "0px",
            boxShadow: "3px 3px 3px 0px #888 inset",
        };
    }

    GetStyleTime() {
        return {
            width: "auto",
            height: "10vh",
            position: "relative",
            margin: "auto",
            marginRight: "0px",
            marginLeft: "1%",
            flex: "none",
            float: "left",
            padding: "0px",
            display: "block",
        };
    }

    //récupération de la couleur du texte à afficher pour être en contraste avec la couleur de l'imputation
    oppositeColor(color, w_b) {
        if (color.indexOf("#") === 0) {
            color = color.slice(1);
        }

        if (color.length === 3) {
            color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
        }
        if (color.length !== 6) {
            throw new Error("Invalid HEX color.");
        }
        let r = parseInt(color.slice(0, 2), 16),
            g = parseInt(color.slice(2, 4), 16),
            b = parseInt(color.slice(4, 6), 16);

        if (w_b) {
            return r * 0.299 + g * 0.587 + b * 0.114 > 148 ? "#000000" : "#FFFFFF";
        } else {
            r = (255 - r).toString(16);
            g = (255 - g).toString(16);
            b = (255 - b).toString(16);

            return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
        }
    }

    darken(color, percent) {
        var num = parseInt(color.slice(1), 16),
            amt = Math.round(2.55 * percent),
            R = (num >> 16) - amt,
            G = ((num >> 8) & 0x00ff) - amt,
            B = (num & 0x0000ff) - amt;
        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
                .toUpperCase()
        );
    }

    //ajout d'un 0 pour avoir toujours deux caractères sur les valeurs hexadécimales
    padZero(str, len) {
        len = len || 2;
        let zeros = new Array(len).join("0");
        return (zeros + str).slice(-len);
    }

    render() {
        let item = this.props.imputation;
        if (item !== undefined && item.activity !== undefined) {
            return (
                <div className="item_list" style={this.GetStyleContainer()}>
                    <div className="schedule-div row" style={{ border: "4px solid " + item.activity.color }}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding span-center">
                            {getTimeString(item.date_start).replace("h", "H")}
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding span-center separator">
                            {" - "}
                        </div>
                        <div
                            className={
                                "col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding span-center " +
                                (item.in_progress ? "in-progress-task" : "")
                            }
                        >
                            {(item.in_progress ? "En cours" : getTimeString(item.date_end)).replace("h", "H")}
                        </div>
                    </div>
                    <div style={this.GetStyleInner(item)} onClick={this.props.openModificationPanel}>
                        <div style={{ paddingLeft: "1%" }}>
                            <Typography style={{ color: this.oppositeColor(item.activity.color, true) }}>
                                {item.activity.name +
                                    (item.business !== "" ? " : " + item.business : item.business) +
                                    (item.commentary !== "" ? " - " + item.commentary : item.commentary)}
                            </Typography>
                            {item.work_order_detail !== undefined ? (
                                <div style={{ paddingTop: 0, marginTop: 0 }}>
                                    <p
                                        style={{
                                            paddingTop: 0,
                                            marginTop: 0,
                                            paddingBottom: 0,
                                            marginBottom: 2,
                                            fontSize: 10,
                                            color: "#333333",
                                        }}
                                    >
                                        {item.work_order_detail.customer}
                                    </p>
                                    <p
                                        style={{
                                            paddingTop: 0,
                                            marginTop: 0,
                                            paddingBottom: 0,
                                            marginBottom: 2,
                                            fontSize: 10,
                                            color: "#333333",
                                        }}
                                    >
                                        {item.work_order_detail.description}
                                    </p>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default DrawListDayItem;
